import Utils from "@/utilities/Utils";
import { TriState } from "@/model/Enums";

export class PagePartSearchParameters {
	id: string = Utils.emptyGuidValue;
    pageID: string = Utils.emptyGuidValue;
    isDeleted: TriState = TriState.False;
}